import React from 'react';
const benefits = [{
  icon: '🚀',
  title: 'Del Básico al Alto Rendimiento',
  desc: 'Una biblioteca definitiva para el docente moderno, con secuencias para cada objetivo.',
  color: 'from-lime-500/20 to-lime-600/5',
  borderColor: 'border-lime-500/20'
}, {
  icon: '💰',
  title: 'Eleva tu Autoridad Técnica',
  desc: 'Estructura profesional que tus alumnos notarán, permitiéndote cobrar lo que realmente vale tu conocimiento.',
  color: 'from-green-500/20 to-green-600/5',
  borderColor: 'border-green-500/20'
}, {
  icon: '📱',
  title: 'Caja de Herramientas de Campo',
  desc: 'Diseñada para ser consultada en vivo, con un enfoque 85% visual y 15% técnico.',
  color: 'from-purple-500/20 to-purple-600/5',
  borderColor: 'border-purple-500/20'
}, {
  icon: '🎓',
  title: 'Metodología EDULABS',
  desc: 'Recibirás el respaldo de utilizar un sistema de planificación validado y estructurado.',
  color: 'from-secondary/20 to-secondary/5',
  borderColor: 'border-secondary/20'
}];
export function BenefitsSection() {
  return <section className="w-full bg-bg-main py-20 px-4" data-id="element-1">
      <div className="max-w-5xl mx-auto" data-id="element-2">
        <h2 className="text-3xl sm:text-5xl font-black text-text-main text-center mb-16 tracking-tight" data-id="element-3">
          El Sistema "Todo en Uno"
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 sm:gap-8" data-id="element-4">
          {benefits.map((benefit, i) => <div key={i} className="bg-bg-alt p-8 rounded-3xl border border-border-light shadow-xl flex flex-col gap-4 hover:-translate-y-1 transition-transform duration-300 relative overflow-hidden group" data-id="element-5">
              <div className={`absolute inset-0 bg-gradient-to-br ${benefit.color} opacity-0 group-hover:opacity-100 transition-opacity duration-500`} data-id="element-6"></div>

              <div className={`w-14 h-14 rounded-2xl bg-bg-dark border ${benefit.borderColor} flex items-center justify-center text-3xl mb-2 relative z-10 shadow-inner`} data-id="element-7">
                {benefit.icon}
              </div>
              <h3 className="text-2xl font-bold text-text-main relative z-10" data-id="element-8">
                {benefit.title}
              </h3>
              <p className="text-text-sec leading-relaxed text-lg relative z-10" data-id="element-9">
                {benefit.desc}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}